module.exports = __webpack_public_path__ + "img/title_register.dbea8168.svg";